const state = {
    // 始终缓存不销毁的页面
    alwaysKeepIncluded: [
        "UserHome",
        "ShopHome",
        "CartTab",
        "ClassifyHome"
    ],
    // 需要缓存的页面
    // 需要在具体页面配置name,注意不是路由里面的name
    keepIncluded: [
        "UserHome",
        "ShopHome",
        "CartTab",
        "ClassifyHome"
    ]
}
export default state